import { Link } from 'react-router';
import { AlertCircle, Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="mb-6 flex justify-center">
          <div className="w-20 h-20 rounded-full bg-orange-100 flex items-center justify-center">
            <AlertCircle className="w-10 h-10 text-orange-600" />
          </div>
        </div>
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-900 mb-2">
          {t('errors.pageNotFound', 'Page Not Found')}
        </h2>
        <p className="text-gray-600 mb-8">
          {t('errors.pageNotFoundMessage', 'The page you are looking for does not exist or has been moved.')}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-[#4F819F] text-white rounded-lg hover:bg-[#4E7F9D] transition-colors"
        >
          <Home className="w-5 h-5" />
          {t('errors.backToHome', 'Back to Home')}
        </Link>
      </div>
    </div>
  );
}
